<template>
    <div class="content">
        <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="88px">
            <el-form-item label="评查指标:" prop="name">
                <el-input style="width:180px;"
                v-model="queryParams.name"
                placeholder="请输入评查指标"
                clearable
                size="small"
                @keyup.enter.native="handleQuery"
                />
            </el-form-item>
            <el-form-item label="评查类型:" prop="alertType">
                <el-select v-model="queryParams.alertType" placeholder="请选择评查类型" clearable size="small" style="width:180px;">
                    <el-option  label="主体" value="主体"/>
                    <el-option  label="证据" value="证据"/>
                    <el-option  label="程序" value="程序"/>
                    <el-option  label="法律" value="法律"/>
                    <el-option  label="案卷文书质量" value="案卷文书质量"/>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="cyan" icon="el-icon-search" size="small" @click="handleQuery">搜索</el-button>
                <el-button icon="el-icon-refresh" size="small" @click="resetQuery">重置</el-button>
            </el-form-item>
        </el-form>

        <el-row :gutter="10" class="mb8">
            <el-col :span="1.5">
                <el-button
                type="primary"
                icon="el-icon-plus"
                size="small"
                @click="handleAdd"
                >新增</el-button>
            </el-col>
        </el-row>
        <br/>
        <el-table v-loading="loading" :data="evaluationList.slice((currentPage-1)*pagesize,currentPage*pagesize)">
            <el-table-column type="selection" width="55" align="center" />
            <el-table-column  align="center" :show-overflow-tooltip="true"  label="序号" width="80">
                <template slot-scope="scope">
                    <span>{{(scope.$index+1) + ( pagesize * (currentPage-1))}}</span>
                </template>
            </el-table-column>
            <el-table-column label="评查指标" prop="name2"/>
            <el-table-column label="评查类型" align="center" prop="name1" width="120" />
            <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="140" >
                <template slot-scope="scope">
                <el-button
                    size="small"
                    type="text"
                    @click="handleUpdate(scope.row)"
                >修改</el-button>
                <el-button
                    size="small"
                    type="text"
                    @click="handleDelete(scope.row.lsh)"
                >删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="page-part" style="padding:20px 20px 50px;">
            <el-pagination
                background
                @size-change='handleSizeChange'
                @current-change='handleCurrentChange'
                :current-page="currentPage"
                :page-sizes="[10,20,30,40]"
                :page-size="pagesize"
                layout="total, prev, pager, next, jumper"
                :total="this.evaluationList.length" style=" float:right;">
            </el-pagination>
        </div>

        <el-dialog title="评查指标" v-loading="loading2" :visible.sync="open" width="800px" append-to-body :close-on-click-modal="false">
            <div class="nr">
                <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                    <el-form-item label="评查类型" prop="name1">
                        <el-select v-model="queryParams.name1" placeholder="请选择评查类型" clearable size="small">
                            <el-option  label="主体" value="主体"/>
                            <el-option  label="证据" value="证据"/>
                            <el-option  label="程序" value="程序"/>
                            <el-option  label="法律" value="法律"/>
                            <el-option  label="案卷文书质量" value="案卷文书质量"/>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="评查指标" prop="name2">
                        <el-input type="textarea" rows="3" v-model="form.name2"></el-input>
                    </el-form-item>
                </el-form>
                <div class="btns" style=" text-align:right;padding-top: 20px;">
                    <el-button type="primary" @click="onSubmit">确定</el-button>
                    <el-button @click="cancel">取消</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
export default {
    name: "Layout",
    data() {
        return {
            loading:false,
            loading2:false,
            queryParams:{
                name:'',
                alertType:'',
            },
            currentPage:1,
            pagesize:10,
            total:0,
            evaluationList:[],
            form:{},
            open: false,
            rules: {
                fileName: [{ required: true, message: "文书名称不能为空", trigger: "blur" }],
                pageCount: [{ required: true, message: "文书页数不能为空", trigger: "blur" }],
            },
        }
    },
    components: {
    },
    computed: {
    },
    created() {
    },
    mounted() {
        this.getList()
    },
    methods: {
        getList(){
        },
        handleAdd(){
            this.open = true
        },
        cancel(){
            this.reset()
            this.open = false
        },
        handleUpdate(row){
            this.open = true
            this.form = row
        },
        handleDelete(lsh){
            this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
            .then(async () => {
                this.$axios.get(`${this.Global._baseUrl}?act=delAnjiann&pcId=${lsh}`)
                .then(res => {
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    this.getList()  
                }).catch(err => {
                    this.$message({
                        message: '删除失败',
                        type: 'error'
                    });
                })	
                    
            })
            .catch(() => {
                this.$message({
                    type: "info",
                    message: "已取消删除"
                });
            });			
        },
        handleSizeChange(val){
            this.pagesize = val
            this.getList()
        },
        handleCurrentChange(val){
            this.currentPage = val
            this.getList()
        },
        onSubmit(){},
        handleQuery(){
            this.currentPage = 1;
            this.getList()
        },
        resetQuery() {
            this.reset();
        },
        reset() {
            this.queryParams = {
                pageNum: 1,
                pageSize: 10,
                name:'',
                alertType:''
            };
        },
    }
}
</script>


<style scoped>
</style>